module.exports = __webpack_public_path__ + "img/doodle-7898618_1280_thumb.af016281.jpg";